import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../../api";
import { AuthenticationRouteDefs } from "../../features/authentication/routing/AuthenticationRouteDefs";
import { SessionService } from "../services/session.service";
import { Session } from "../util/Session";

@Injectable({
  providedIn: "root",
})
export class SessionGuard implements CanActivate {
  disable = true;
  router = inject(Router);
  session = inject(SessionService);
  auth = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    if (this.disable) {
      return new Promise((resolve) => {
        (async () => {
          resolve(true);
        })();
      });
    }

    return new Promise((resolve) => {
      (async () => {
        const sessionInfo = this.session.getSessionInfo()();
        const login = this.session.getNetworkInfo();

        // Wait for the network info query to complete
        while (this.session.envQuery.isLoading()) {
          await new Promise((resolve) => setTimeout(resolve, 100));
        }

        if (
          Session.getAuthToken() == null ||
          (!sessionInfo && !this.session.sessionInfoQuery.isLoading() && !this.session.sessionInfoQuery.isSuccess())
        ) {
          console.warn("No session information available");
          Session.clearAuthToken();

          const redirectRoute =
            (login() ?? false)
              ? AuthenticationRouteDefs.getFQRMissingNotice()
              : AuthenticationRouteDefs.getFQRMissingNotice();
          this.router.navigate([redirectRoute]);
          resolve(false);
        } else {
          resolve(true);
        }
      })();
    });
  }
}
